module.exports = __webpack_public_path__ + "images/1042f1b938f31120893e6711954c9c1822.svg";